import React, { useState } from "react";
import styles from "./CustomizedField.module.css";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import deleteImage from "./Images/delete.svg";
import DeleteBtn from "../../../../../../../../components/Buttons/DeleteBtn";
import DeletePopup from "../../../../../../../../components/CommonPopups/DeletePopup";
import EditIconBtn from "../../../../../../../../components/Buttons/EditIconBtn";
import CancelBtn from "../../../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../../../components/Buttons/SaveBtn";

function CustomizedImageField(props: any) {
  const {
    onFieldChange,
    field,
    onDelete,
    isTextFieldFocused,
    setIsTextFieldFocused,
    leadsFromResponseChecked,
    edit = false,
    deleteAction = false,
    mandatory = false,
    isNameUniqueCheck,
  } = props;
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [question, setQuestion] = useState<string>("");

  const handleDeleteConfirmed = () => {
    setShowDeletePopup(false);
    onDelete(field);
  };

  const handleDeleteCancelled = () => {
    setShowDeletePopup(false);
  };

  const handleMandatoryChange = (e: any) => {
    const isMandatory = e.target.checked;
    onFieldChange({
      ...field,
      required: isMandatory,
    });
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };
  const handleQuestionChange = (e: any) => {
    setQuestion(e.target.value);
  };
  const handleSaveClick = (e: any) => {
    onFieldChange({
      ...field,
      fieldName: question,
    });

    setIsEditing(false);
  };
  const handleCancelClick = () => {
    setIsEditing(false);
  };
  return (
    <div className={styles.customizedFieldWrapper}>
      <div className={styles.customizedFieldTop}>
        <div className={styles.label}>
          {field.fieldName}
          {field.required === true && <span style={{ color: "red" }}>*</span>}
        </div>
        {!isEditing && (
          <div className={styles.customizedFieldTopRight}>
            {edit && <EditIconBtn onClick={handleEditClick} />}
            {deleteAction && (
              <DeleteBtn
                icon={deleteImage}
                onClick={() => setShowDeletePopup(!showDeletePopup)}
              />
            )}

            {showDeletePopup && (
              <DeletePopup
                open={showDeletePopup}
                onClose={handleDeleteCancelled}
                noBtnClick={handleDeleteCancelled}
                yesBtnClick={handleDeleteConfirmed}
                title={"Are you sure you want to delete this question?"}
              />
            )}
          </div>
        )}
      </div>
      <div className={styles.description}>
        Maximum size 2MB and file should be in JPG/JPEG format
      </div>
      <TextField
        // placeholder={field.isCustom ? "Write a question" : ""}
        placeholder={isEditing ? field?.fieldName : ""}
        value={isEditing ? question : ""}
        onChange={handleQuestionChange}
        fullWidth
        variant="outlined"
        disabled={!isEditing}
        size="small"
        // inputProps={{
        //   style: {
        //     padding: "8px 12px",
        //     backgroundColor: "#FAFAFA",
        //     borderRadius: "4px",
        //   },
        // }}
        // draggable={!isTextFieldFocused}
        // onFocus={() => {
        //   setIsTextFieldFocused(true);
        // }}
        // onBlur={() => {
        //   setIsTextFieldFocused(false);
        // }}
        // error={!isNameUniqueCheck(question, field?.index)}
        // helperText={
        //   !isNameUniqueCheck(question, field?.index)
        //     ? "Field label already exist"
        //     : ""
        // }
        inputProps={{
          style: {
            padding: "8px 12px",
            backgroundColor: isEditing ? "#FFFFFF" : "#FAFAFA",
            borderRadius: "4px",
          },
        }}
        error={isEditing && !isNameUniqueCheck(question, field?.index)}
        helperText={
          isEditing && !isNameUniqueCheck(question, field?.index)
            ? "Field label already exist"
            : ""
        }
      />
      {mandatory && (
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              onChange={handleMandatoryChange}
              checked={field?.required}
              sx={{
                strokeWidth: 1,
                color: "#D0D5DD",
              }}
            />
          }
          label="Mandatory"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "13px",
              color: "#667085",
              lineHeight: "20px",
            },
          }}
        />
      )}
      {isEditing && (
        <div className={styles.btnsWrap}>
          <CancelBtn onClick={handleCancelClick} />
          <SaveBtn
            onClick={handleSaveClick}
            disabled={
              !question.trim() || !isNameUniqueCheck(question, field?.index)
            }
          />
        </div>
      )}
    </div>
  );
}

export default CustomizedImageField;
